module.exports = __webpack_public_path__ + "img/icon_trade_eye_normal@3x.d1caa490.png";